/*
 *  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 *  Licensed under the Apache License, Version 2.0 (the "License").
 *  You may not use this file except in compliance with the License.
 *  A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 *  or in the "license" file accompanying this file. This file is distributed
 *  on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 *  express or implied. See the License for the specific language governing
 *  permissions and limitations under the License.
 */
import React from 'react';
import _ from 'lodash';
import { Input } from 'semantic-ui-react';

// expected props
// - onSearchChange (function) — callback receiving the search string
// - viewControl (node) — optional control rendered in its own row above the search bar (e.g. view toggle)
// - children (node) — optional content rendered to the right of the search bar (e.g. filter buttons)
export default function CatalogueHeader({ onSearchChange, viewControl, children }) {
  return (
    <div className="mb3 workspace-list-header catalogue-list-header">
      {viewControl && <div className="workspace-list-header-top">{viewControl}</div>}
      <div className="workspace-search-filter-row">
        <div className="workspace-search-box">
          <Input
            fluid
            className="rounded-input"
            placeholder="Search products..."
            icon="search"
            iconPosition="left"
            onChange={_.debounce((e, data) => onSearchChange(data.value), 500)}
          />
        </div>
        {children && <div className="workspace-filter-row">{children}</div>}
      </div>
    </div>
  );
}
